import { clsx } from "clsx";
import "./Button.scss";

interface IButtonProps extends React.ComponentPropsWithRef<"button">{
  variant: "primary" | "secondary" | "ghost";
  size: "xl" | "l" | "m" | "s" | "xs";
  children: React.ReactNode;
  round?: boolean;
  fullWidth?: boolean;
}

export const Button: React.FC<IButtonProps> = ({
  variant,
  size,
  children,
  round,
  fullWidth,
  ...restProps
}) => {
  return (
    <button
      className={clsx(
        "Button",
        `Button_${variant}`,
        `Button_${size}`,
        round && "Button_isRound",
        fullWidth && "Button_fullWidth",
      )}
      {...restProps}
    >
      <div className="Button-Wrap">{children}</div>
    </button>
  );
};

